import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (process.env.NODE_ENV === "production") {
  registerServiceWorker();
} else {
  // Em dev, registramos mesmo assim para testar notificações
  if ("serviceWorker" in navigator) {
    registerServiceWorker();
  }
}
